import React from 'react';
import { Col, ColProps, Container, Row } from 'reactstrap';
import classNames from 'classnames';
import {
  faFingerprint,
  faWifi,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import {
  faDotCircle,
  faEye,
  faHandPaper,
  faSmile,
} from '@fortawesome/free-regular-svg-icons';
import { faBluetoothB } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Flex, FlexAlign } from '../../../components/ui-lib/Flex';

interface IdentificationMediumProps {
  title: string;
  icon: IconDefinition;
}

const IdentificationMedium: React.FC<IdentificationMediumProps> = props => {
  const { title, icon, children } = props;

  const containerClassName = classNames('mx-auto', 'mb-5', 'text-center');

  const iconContainerClassName = classNames(
    // 'circle-4',
    // 'bg-dark',
    // 'text-primary',
    // 'shadow',
    // 'text-green-shade-03',
    // 'text-blue-shade-03',
    'text-purple-shade-00',
    'mx-auto',
    'mb-3'
  );

  const subtextClassName = classNames('font-size-sm', 'text-gray-600');

  return (
    <div className={containerClassName}>
      <Flex
        justify="center"
        align={FlexAlign.Center}
        className={iconContainerClassName}
      >
        <FontAwesomeIcon icon={icon} size="3x"></FontAwesomeIcon>
      </Flex>

      <h5>{title}</h5>
      <p className={subtextClassName}>{children}</p>
    </div>
  );
};

interface TypeTitleProps {
  prefix: string;
}

const TypeTitleRow: React.FC<TypeTitleProps> = props => {
  const { prefix, children } = props;

  return (
    <Row className="mt-5 mb-3">
      <Col className="text-center">
        <h5 className="mb-4 lh-base">
          <mark className="bg-dark text-light rounded-sm">{prefix}</mark>{' '}
          Identifikationmedien
        </h5>
        <p>{children}</p>
      </Col>
    </Row>
  );
};

const BiometricIM: React.FC = props => {
  const mediumColProps: ColProps = {
    xs: 12,
    sm: 6,
    lg: 3,
  };
  return (
    <Container>
      <TypeTitleRow prefix="Biometrische">
        Mit Hilfe biometrischer Identifikationsmedien tragen Sie Ihren Schlüssel
        immer bei sich.
      </TypeTitleRow>

      <Row>
        <Col {...mediumColProps}>
          <IdentificationMedium
            title="Fingerabdruckscan"
            icon={faFingerprint}
          ></IdentificationMedium>
        </Col>
        <Col {...mediumColProps}>
          <IdentificationMedium
            title="Iriserkennung"
            icon={faEye}
          ></IdentificationMedium>
        </Col>
        <Col {...mediumColProps}>
          <IdentificationMedium
            title="Gesichtserkennung"
            icon={faSmile}
          ></IdentificationMedium>
        </Col>
        <Col {...mediumColProps}>
          <IdentificationMedium
            title="Handvenenerkennung"
            icon={faHandPaper}
          ></IdentificationMedium>
        </Col>
      </Row>
    </Container>
  );
};

const PassiveIM: React.FC = props => {
  const mediumColProps: ColProps = {
    xs: 12,
    sm: 4,
  };
  return (
    <Container>
      <TypeTitleRow prefix="Passive">
        Der Vorteil passiver Identifikationsmedien ist, dass für Ihren Einsatz -
        anders als etwa bei Fernbedienungen - keine Batterien benötigt werden.
      </TypeTitleRow>
      <Row className="justify-content-center">
        <Col {...mediumColProps}>
          <IdentificationMedium title="berührungslos" icon={faWifi}>
            unterschiedliche RFID-Technologien
          </IdentificationMedium>
        </Col>
        {/* <Col {...mediumColProps}>
          <IdentificationMedium title="kontaktbehaftet" icon={faDotCircle}>
            Zum Beispiel mittels Magnetstreifen
          </IdentificationMedium>
        </Col> */}
        <Col {...mediumColProps}>
          <IdentificationMedium title="Bluetooth" icon={faBluetoothB}>
            Ihr Handy als Schlüssel
          </IdentificationMedium>
        </Col>
      </Row>
    </Container>
  );
};

export const IdentificationMedia: React.FC = props => {
  return (
    <Container fluid className="bg-light py-6 px-4">
      <Row>
        <Col>
          <h2>Sesam öffne dich.</h2>
          {/* <hr /> */}
          <p className="lead">
            Sparen Sie sich viel Ärger - mit der Wahl des richtigen
            Identifikationsmediums.
          </p>
        </Col>
      </Row>

      <hr />
      <PassiveIM />
      <hr />
      <BiometricIM />
    </Container>
  );
};
